module.exports = __webpack_public_path__ + "img/close-circle-line.e521c673.svg";